import NavbarWidget from './NavbarWidget';

export default NavbarWidget;
